import { PURGE } from "redux-persist";

const initialState = {
  stats: {},
  voices: [],
  error: null,
  allModels: [],
  allAgents: null,  // Changed from [] to null to differentiate "not loaded" vs "empty"
  singleAgent: {},
  isLoading: false,
  ttsProviders: [],
  allTemplateAgents: [],
  connectionDetails: {},
  voiceAgentStatus: null,
  newAgentModal: false,
  agentsFetched: false,  // Added to track if agents have been fetched
  allAgentsLoading: false,  // Added to track loading state
};

const agent = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE:
      return initialState;

    case 'SET_ALL_TEMPLATE_AGENTS':
      return {
        ...state,
        allTemplateAgents: payload,
      };

    case 'GET_ALL_AGENTS':
      return {
        ...state,
        isLoading: true,
        allAgentsLoading: true,
      };
    
    case 'GET_SINGLE_AGENT':
      return {
        ...state,
        isLoading: true,
      };

    case 'SET_ALL_AGENTS':
      return {
        ...state,
        allAgents: payload || [],  // Ensure empty array if no agents
        isLoading: false,
        allAgentsLoading: false,
        agentsFetched: true,  // Mark as fetched
      };

    case 'SET_NEW_AGENT_MODAL':
      return {
        ...state,
        newAgentModal: payload,
      };

    case 'SET_SINGLE_AGENT':
      return {
        ...state,
        isLoading: false,
        voices: payload['voices'],
        providers: payload['providers'],
        singleAgent: payload['singleAgent'],
        ttsProviders: payload['ttsProviders'] || [],
        stats: payload['singleAgent']?.['stats'],
        allModels: payload['providers']?.['text'] || [],
      };

    case 'UPDATE_AGENT_SUCCESS':
      return {
        ...state,
        singleAgent: payload,
        stats: payload['stats']
      };

    case 'ADD_AGENT':
      return {
        ...state,
      };

    case 'SET_CONNECTION_DETAILS':
      return {
        ...state,
        connectionDetails: payload,
      };

    case "CLEAR_CONNECTION_DETAILS":
      return { ...state, connectionDetails: {} };

    case 'SET_VOICE_AGENT_STATUS':
      return { ...state, voiceAgentStatus: payload };

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: true,
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: payload,
        isLoading: false,
      };


    case 'LOGOUT':
      return initialState;

    default:
      return state;
  }
};

export default agent;
